import React, { useEffect, useState } from 'react'
import { Card, Button, Avatar, Typography, Row, Col, Divider, message } from "antd";
import { EditOutlined, CameraOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons";
import TopBar from '../../components/TopBar/Navbar';
import "./Profile.css";
const { Title, Text } = Typography;
export const Profile = () => {
  const [dataUser, setDataUser] = useState([])
  useEffect(() => {
    const storedUser = localStorage.getItem("userData");
    setDataUser(JSON.parse(storedUser));
  }, [])

  const handleChangeAvatar = () => {
    message.info("Change Avatar")
  }

  const handleChangeInfo = () => {
    message.info("Change info")
  }

  console.log(dataUser)

  return (
    <div>
      <TopBar />
      <div className="profile-container">
        <Card className="profile-card">
          <Title level={3} className="profile-header">Thông tin cá nhân</Title>
          <Divider />
          <Row align="middle" justify="center">
            <Col>
              <Title level={2} className="profile-name">
                <span style={{ color: '#fff' }}>{dataUser.user_fullname}</span>
              </Title>
              <Text type="secondary" className="profile-role">
                {dataUser.type_info}
              </Text>
            </Col>
          </Row>
          <Row align="middle" justify="center">
            {/* Avatar + Change Photo */}
            <Col className="avatar-section">
              <div className="avatar-container">
                <Avatar
                  size={140}
                  src={dataUser.avatar || 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQs9gUXKwt2KErC_jWWlkZkGabxpeGchT-fyw&s'}
                  className="profile-avatar"
                />
                <Button onClick={handleChangeAvatar} type="text" icon={<CameraOutlined />} className="change-photo-btn" />
              </div>
            </Col>
          </Row>
          {/* Thông tin người dùng */}
          <Row align="middle" justify="center">
          <Col>
            <Button onClick={handleChangeInfo} type="primary" icon={<EditOutlined />} className="edit-profile-btn">
              Chỉnh sửa
            </Button>
            </Col>
          </Row>

          <Divider />

          {/* Tab thông tin */}
          <div className="profile-tabs">
            <Text className="active-tab">Thông tin</Text>
          </div>

          {/* Chi tiết thông tin */}
          <div className="profile-info">
            <p><strong>Họ tên:</strong> {dataUser.user_fullname}</p>
            <p><strong>Email:</strong> {dataUser.email}</p>
            <p><strong>Tài khoản:</strong> {dataUser.type_info}</p>
            {/* <p><strong>Phone:</strong> 123 456 7890</p> */}
            <p><strong>ID:</strong> {dataUser.user_id}</p>
          </div>
        </Card>
      </div>
    </div>
  );
}

export default Profile;
